import React, { SVGProps } from 'react';

const SvgCustomYarn = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none"  {...props}>
		<path d="M3.5 18C2.95 18 2.47933 17.8043 2.088 17.413C1.69667 17.0217 1.50067 16.5507 1.5 16V3H0.5V1H5.5V0H11.5V1H16.5V3H15.5V16C15.5 16.55 15.3043 17.021 14.913 17.413C14.5217 17.805 14.0507 18.0007 13.5 18H3.5ZM13.5 3H3.5V16H13.5V3ZM5.5 14H7.5V5H5.5V14ZM9.5 14H11.5V5H9.5V14Z" fill="#8E98A7" />
	</svg>
);
export default SvgCustomYarn;

